<template>
    <v-app>
        <v-main>
            <v-container>
                <v-row align="center" justify="center">
                    <LoaderComponent></LoaderComponent>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="10" md="8" lg="8" xl="6">
                        <v-card class="elevation-6 mt-15">
                            <v-window v-model="step">
                                <v-window-item :value="1">
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-card-text class="mt-12">
                                                <h2 class="text-center"> ລະບົບຂາຍປະກັນໄພ </h2>

                                                <v-form ref="login_form" @submit.prevent="Login">
                                                    <v-row align="center" justify="center">

                                                        <v-col cols="12" sm="10">
                                                            <v-alert v-if="error" dense outlined type="error"
                                                                class="mt-5">
                                                                Incorrect username or password
                                                            </v-alert>
                                                            <v-text-field :label="$t('POLICY.EMAIL')" outlined dense
                                                                :rules="rules.username" color="green darken-4"
                                                                autocomplete="false" v-model="credential.username"
                                                                class="mt-10" />
                                                            <v-text-field :label="$t('LOGIN.PASSWORD')" outlined dense
                                                                :rules="rules.password" color="green darken-4"
                                                                autocomplete="false" type="password"
                                                                v-model="credential.password" />

                                                            <v-btn type="submit" color="green darken-4" dark block
                                                                tile>{{ $t('LOGIN.SIGN_IN') }}
                                                            </v-btn>


                                                        </v-col>

                                                    </v-row>
                                                </v-form>
                                            </v-card-text>
                                        </v-col>
                                        <v-col cols="12" md="6" class="green darken-4 rounded-bl-xl">
                                            <div style="  text-align: center; padding: 180px 0;">
                                                <v-card-text class="white--text">
                                                    <h3 class="text-center ">PHONGSAVANH INSURANCE (APA) CO.,LTD</h3>
                                                    <h5 class="text-center"> You're not just another
                                                        customer...<br>We're not just another Insurer...</h5>
                                                </v-card-text>
                                                <div class="text-center">
                                                    <v-btn tile outlined dark @click="step++">ລົງທະບຽນ</v-btn>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item :value="2">
                                    <v-row>
                                        <v-col cols="12" md="6" class="yellow darken-3 rounded-br-xl">
                                            <div style="  text-align: center; padding: 180px 0;">
                                                <v-card-text class="white--text">
                                                    <h3 class="text-center ">Already Signed up?</h3>
                                                    <h6 class="text-center">Log in to your account so you can continue
                                                        building and<br> editing
                                                        your onboarding flows</h6>
                                                </v-card-text>
                                                <div class="text-center">
                                                    <v-btn tile outlined dark @click="step--">Log in</v-btn>
                                                </div>
                                            </div>
                                        </v-col>

                                        <v-col cols="12" md="6">
                                            <v-card-text class="mt-12">
                                                <h4 class="text-center">Sign Up for an Account</h4>
                                                <h6 class="text-center  grey--text ">Let's get you all set up so you can
                                                    start creatin your <br>
                                                    first onboarding experiance</h6>
                                                <v-form ref="signup_form" @submit.prevent="SignUp">
                                                    <v-row align="center" justify="center">
                                                        <v-col cols="12" sm="12">
                                                            <!-- <v-text-field v-model="user_data.user_full_name"
                                                                label="Full Name" outlined dense :rules="required_rules"
                                                                color="green darken-4" autocomplete="false"
                                                                class="mt-4" />
                                                            <v-select v-model="user_data.user_group_id" dense
                                                                :rules="required_rules"
                                                                prepend-icon="mdi-account"
                                                                :items="gender_item" :item-value="'id'"
                                                                :item-text="'name'" clearable
                                                                :label="$t('LOGIN.GROUP_NAME')"></v-select>
                                                            <v-select v-model="border_access" dense
                                                                :rules="required_rules" prepend-icon="mdi-access-point"
                                                                :items="border_item" :item-value="'id'"
                                                                :item-text="'name'" clearable
                                                                :label="$t('POLICY.BORDER')"></v-select> -->
                                                            <v-text-field label="Email" v-model="user_data.user_email"
                                                                :rules="emailRules" outlined dense
                                                                color="green darken-4" autocomplete="false" />
                                                            <v-text-field label="Password"
                                                                v-model="user_data.user_password"
                                                                :rules="required_rules" outlined dense
                                                                color="green darken-4" autocomplete="false"
                                                                type="password" />
                                                            <!-- <v-row>
                                                            <v-col cols="12" sm="7">
                                                                <v-checkbox

                                                                        label="I Accept AAE"
                                                                        class="mt-n1"
                                                                        color="green darken-4"
                                                                ></v-checkbox>
                                                            </v-col>
                                                            <v-col cols="12" sm="5">
                                                                <span class="caption green--text ml-n4 text--darken-4">Terms &Conditions</span>
                                                            </v-col>
                                                        </v-row> -->
                                                            <v-btn type="submit" color="yellow darken-3 " dark
                                                                block>Sign
                                                                up</v-btn>


                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </v-card-text>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                            </v-window>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>

</template>

<script>
import LoaderComponent from "@/components/Loader";
import Swal from 'sweetalert2'
export default {
    name: 'LoginView',
    components: { LoaderComponent },
    data: () => ({
        step: 1,
        credential: {
            username: '',
            password: ''
        },
        rules: {
            username: [
                v => !!v || "Username required"
            ],
            password: [
                v => !!v || "Password required"
            ]
        },
        group_item: [
            { id: 1, name: 'Individual' },
            { id: 2, name: 'Group Tour' },
        ],
        required_rules: [
            v => !!v || 'required'
        ],
        emailRules: [
            v => !!v || 'Email is required',  // Required field
            v => /.+@.+\..+/.test(v) || 'Email must be valid' // Basic email check
        ],
        border_item: [
            { id: '1', name: 'Lao-Thai Friendship Bridge 1' },
            { id: '2', name: 'Wattay International Airport' },
        ],
        user_data: {
            user_email: '',
            user_password: ''
        },
        border_access: '',
        error: false
    }),
    mounted() {
        // this.getBorder()
    },
    methods: {
        async Login() {
            if (!this.$refs.login_form.validate()) {
                return
            }
            try {
                let r = await window.axios.post('login', this.credential)
                console.log(r)
                const { token, user_role, user_id, group_id,is_updated, province_id } = r.data
                await this.$store.dispatch('login', { token, user_role, user_id, group_id, province_id })
                await this.$store.dispatch('setUpdateUser', { is_updated, group_id })
                // Landing page by role
                if (user_role === 'user') {
                    await this.$router.push({ name: 'travel' })
                } else {
                    // admin / government / local_government -> dashboard
                    await this.$router.push({ name: 'home' })
                }
                // localStorage.setItem('is_updated',r.data.is_updated)
            } catch (e) {
                this.error = true
                setTimeout(() => {
                    this.error = false
                }, 3000)
                console.log(e.response.data )
            }
        },
        async getBorder() {
            try {
                const r = await window.axios.get('getborder/')
                this.border_item = r.data
            } catch (e) {
                console.log(e)
            }
        },
        async SignUp() {
            if (!this.$refs.signup_form.validate()) {
                return
            }
            try {
                const r = await window.axios.post('signup', this.user_data)
                if (r.data.status == 'N') {
                    Swal.fire({
                        title: 'Warning!',
                        text: r.data.msg,
                        icon: 'warning',
                        showConfirmButton: true,
                        confirmButtonText: 'Ok'
                    })
                    return
                }
                // Reset form
                this.$refs.signup_form.reset()
                this.$refs.signup_form.resetValidation()

                const result = await Swal.fire({
                    title: 'Success!',
                    text: r.data.msg,
                    icon: 'success',
                    showConfirmButton: true,
                    confirmButtonText: 'Ok'
                })

                if (result.isConfirmed) {
                    // Switch window
                    this.step = 1
                }
                console.log(r.data.msg)
            } catch (e) {
                console.log(e)
            }
        }
    }
}
</script>

<style scoped>
.v-application .rounded-bl-xl {
    border-bottom-left-radius: 300px !important;
}

.v-application .rounded-br-xl {
    border-bottom-right-radius: 300px !important;
}
</style>